import { serviceApi, withServiceRequestDefaults } from 'Shared/network';
import type { GetExchangesResponse } from 'viewup-api/v2';

export interface GetExchangesReq {
  limit: number;
  page: number;
}

export const getExchanges = async ({
  limit,
  page,
}: GetExchangesReq): Promise<GetExchangesResponse> => {
  const response = await serviceApi.exchanges.getExchanges(
    withServiceRequestDefaults({
      limit,
      page,
    }),
  );

  return response.data;
};
